import { FACTURATION_REDUCER_NAME } from './constants';
import { FACTURES_OPEN_SEARCH_SLICE_NAME } from './slices/factureOpenSearchSlice';
import { FacturationStateType } from './types';

export const FactureOpenSearchSelector = (s: FacturationStateType) =>
    s[FACTURATION_REDUCER_NAME][FACTURES_OPEN_SEARCH_SLICE_NAME];
export const FactureOpenSearchSelectorMain = (s: FacturationStateType) =>
    s[FACTURATION_REDUCER_NAME][FACTURES_OPEN_SEARCH_SLICE_NAME].main;
